import { CheckCircle, Circle, Warning } from "@phosphor-icons/react";

// Internal-only Admin Review helpers. Never used on public pages.
export const REVIEW_EDITOR_ROLES = ["owner", "admin_input", "admin"];
export const reviewOf = (p) => p?.review_status || "TO_CHECK";

export const fmtReviewDate = (iso, withTime = false) => {
    if (!iso) return "";
    const d = new Date(iso);
    const opts = { timeZone: "Asia/Jakarta", day: "numeric", month: "short", ...(withTime ? { year: "numeric" } : {}) };
    const date = d.toLocaleDateString("en-GB", opts);
    if (!withTime) return date;
    const time = d.toLocaleTimeString("en-GB", { timeZone: "Asia/Jakarta", hour: "2-digit", minute: "2-digit" });
    return `${date} · ${time}`;
};

export const reviewTitle = (p) => {
    const s = reviewOf(p);
    if (s === "CHECKED") return `Checked by ${p.checked_by_name || "—"} · ${fmtReviewDate(p.checked_at, true)}`;
    return s === "RECHECK" ? "Needs recheck" : "To check";
};

// Compact cell: "○ TO CHECK" / "✓ Nadia 17 Oct" / "⚠ RECHECK".
export function ReviewBadge({ product, compact = false, testId }) {
    const s = reviewOf(product);
    const title = reviewTitle(product);
    if (s === "CHECKED") {
        return (
            <span title={title} data-testid={testId} className="inline-flex items-center gap-1 text-[#3F6B4E] leading-tight">
                <CheckCircle size={compact ? 12 : 14} weight="fill" className="shrink-0" />
                {!compact && (
                    <span className="text-[12px]">
                        <span className="font-medium">{(product.checked_by_name || "").split(" ")[0]}</span>
                        <span className="block text-[11px] text-neutral-500">{fmtReviewDate(product.checked_at)}</span>
                    </span>
                )}
            </span>
        );
    }
    if (s === "RECHECK") {
        return (
            <span title={title} data-testid={testId} className="inline-flex items-center gap-1 text-[#9A7414] text-[11px] uppercase tracking-wider font-medium whitespace-nowrap">
                <Warning size={compact ? 12 : 13} weight="fill" className="shrink-0" />{!compact && "Recheck"}
            </span>
        );
    }
    return (
        <span title={title} data-testid={testId} className="inline-flex items-center gap-1 text-neutral-500 text-[11px] uppercase tracking-wider whitespace-nowrap">
            <Circle size={compact ? 11 : 12} className="shrink-0" />{!compact && "To check"}
        </span>
    );
}
